import { render } from "./ChooseAddressList.vue?vue&type=template&id=1b1e83d1&scoped=true&bindings={\"addressList\":\"setup\",\"handleBackClick\":\"setup\",\"handleAddressClick\":\"setup\"}"
import script from "./ChooseAddressList.vue?vue&type=script&lang=js"
export * from "./ChooseAddressList.vue?vue&type=script&lang=js"

import "./ChooseAddressList.vue?vue&type=style&index=0&id=1b1e83d1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b1e83d1"

export default script